import { useBookingRowsContext } from "PFApp/booking/parts/overview/context/booking_rows_context";
import { filterRolesByActivityId } from "PFApp/booking/parts/overview/context/booking_rows_context/booking_rows_context.utils";
import { CalendarMode } from "PFApp/booking/types";
import { useActivityInvalidate } from "PFCore/hooks/queries/activity";
import { Id } from "PFTypes";
import { useCallback } from "react";

export const useInvalidateSelectedActivitiesWarnings = () => {
  const {
    selectEditMode: { selection },
    rowsByCalendarMode
  } = useBookingRowsContext();
  const { invalidateActivityWarnings } = useActivityInvalidate();

  const invalidateSelectedActivitiesWarnings = useCallback(() => {
    const activityIds: Id[] =
      (selection?.filters
        .flatMap(({ activityId }) => activityId)
        .filter((activityId) => activityId !== undefined) as Id[]) ?? [];

    activityIds.forEach((activityId) => {
      const roles = filterRolesByActivityId(activityId, rowsByCalendarMode[CalendarMode.Projects]);
      roles.forEach((role) => invalidateActivityWarnings(role.original.id));
    });
  }, [selection, rowsByCalendarMode]);

  return { invalidateSelectedActivitiesWarnings };
};
